import React from 'react';
import { Icon, IconSize } from '@askporter/component-library/Icon';
import { SxProps } from '@mui/system/styleFunctionSx';
import { LinkedTaskMenuOptions, OptionType } from '@askporter/utils';
// given the importance of colour in this scenario, opting to include svg so the colour can be dynamically changed
const mdDeleteIconSvg = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>actions / 04-delete / 24px</title>
    <g id="actions-/-04-delete-/-24px" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="trash-alt" transform="translate(3.000000, 2.000000)">
        <path
          d="M11.8928571,16.875 L12.5357143,16.875 C12.7132344,16.875 12.8571429,16.735089 12.8571429,16.5625 L12.8571429,5.9375 C12.8571429,5.76491102 12.7132344,5.625 12.5357143,5.625 L11.8928571,5.625 C11.715337,5.625 11.5714286,5.76491102 11.5714286,5.9375 L11.5714286,16.5625 C11.5714286,16.735089 11.715337,16.875 11.8928571,16.875 Z M5.46428571,16.875 L6.10714286,16.875 C6.28466296,16.875 6.42857143,16.735089 6.42857143,16.5625 L6.42857143,5.9375 C6.42857143,5.76491102 6.28466296,5.625 6.10714286,5.625 L5.46428571,5.625 C5.28676562,5.625 5.14285714,5.76491102 5.14285714,5.9375 L5.14285714,16.5625 C5.14285714,16.735089 5.28676562,16.875 5.46428571,16.875 Z M17.6785714,2.5 L13.5,2.5 L12.15,0.75 C11.7857808,0.277864045 11.2141748,-4.16333634e-16 10.6071429,-4.16333634e-16 L7.39285714,-4.16333634e-16 C6.7858252,-4.16333634e-16 6.21421917,0.277864045 5.85,0.75 L4.5,2.5 L0.321428571,2.5 C0.143908473,2.5 0,2.63991102 0,2.8125 L0,3.4375 C0,3.61008898 0.143908473,3.75 0.321428571,3.75 L1.28571429,3.75 L1.28571429,18.125 C1.28571429,19.1605339 2.14916513,20 3.21428571,20 L14.7857143,20 C15.8508349,20 16.7142857,19.1605339 16.7142857,18.125 L16.7142857,3.75 L17.6785714,3.75 C17.8560915,3.75 18,3.61008898 18,3.4375 L18,2.8125 C18,2.63991102 17.8560915,2.5 17.6785714,2.5 Z M6.87857143,1.5 C7.0003906,1.34310297 7.1906618,1.25061002 7.39285714,1.25 L10.6071429,1.25 C10.8093382,1.25061002 10.9996094,1.34310297 11.1214286,1.5 L11.8928571,2.5 L6.10714286,2.5 L6.87857143,1.5 Z M15.4285714,18.125 C15.4285714,18.470178 15.1407545,18.75 14.7857143,18.75 L3.21428571,18.75 C2.85924552,18.75 2.57142857,18.470178 2.57142857,18.125 L2.57142857,3.75 L15.4285714,3.75 L15.4285714,18.125 Z M8.67857143,16.875 L9.32142857,16.875 C9.49894867,16.875 9.64285714,16.735089 9.64285714,16.5625 L9.64285714,5.9375 C9.64285714,5.76491102 9.49894867,5.625 9.32142857,5.625 L8.67857143,5.625 C8.50105133,5.625 8.35714286,5.76491102 8.35714286,5.9375 L8.35714286,16.5625 C8.35714286,16.735089 8.50105133,16.875 8.67857143,16.875 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </svg>
);
interface Params {
  permittedMenuOptions: LinkedTaskMenuOptions[];
  isSmallDevice: boolean;
  handlers: Record<LinkedTaskMenuOptions, () => void>;
  iconPaths: Record<string, string>;
  displayNames: Record<LinkedTaskMenuOptions, string>;
  navigationPaths?: Partial<Record<LinkedTaskMenuOptions, string>>;
}
export const generateMenuOptions = ({
  permittedMenuOptions,
  isSmallDevice,
  handlers,
  iconPaths,
  displayNames,
  navigationPaths,
}: Params): OptionType<LinkedTaskMenuOptions, SxProps>[] => {
  const options: OptionType<LinkedTaskMenuOptions, SxProps>[] = [];
  if (permittedMenuOptions.includes('VIEW_TASK')) {
    const key: LinkedTaskMenuOptions = 'VIEW_TASK';
    const path = navigationPaths?.[key];
    options.push({
      optionKey: key,
      dataTestId: `${key}_option`,
      ...(path ? { to: path } : { handleClick: handlers[key] }),
      name: displayNames[key],
      icon: !isSmallDevice && <Icon size={IconSize.MD} fullPath={iconPaths[key]} folder="system/01-tasks" />,
    });
  }
  if (permittedMenuOptions.includes('DELETE')) {
    const key: LinkedTaskMenuOptions = 'DELETE';
    options.push({
      optionKey: key,
      dataTestId: `${key}_option`,
      handleClick: handlers[key],
      name: displayNames[key],
      icon: !isSmallDevice && mdDeleteIconSvg,
      isDangerStyle: true,
    });
  }
  return options;
};
